import React from "react";
import { IUsageRowData } from "../../../types/usageTypes/IUsageRowData";

interface IMetaDataType {
    name: string;
    title?: string;
    type?: string;
    // For contributors
    ipiNumber?: string;
    // For names
    language?: string;
}

const UsageMetaDataView: React.FC<{
  usageType: string;
  contributorTypes?: string[];
  nameTypes?: string[];
  usages: IUsageRowData[];
  toggleExtendedMetaData: () => void;
  isExtendedMetaDataOpen: boolean;
  
}> = ({ 
    usageType,
    contributorTypes,
    nameTypes,
    usages,
    toggleExtendedMetaData,
    isExtendedMetaDataOpen
 }) => {
    const [metaData, setMetaData] = React.useState<IMetaDataType[]>([]);
    const isUsageToProduct = usageType === "UsageToProduct";

    React.useEffect(() => {
        if (!isUsageToProduct && usages && usages?.length > 0 && usages[0]?.contributors?.length > 0) {
            setMetaData(usages[0]?.contributors || []);
        }
        if (isUsageToProduct && usages && usages?.length > 0 && usages[0]?.names?.length > 0) {
            setMetaData(usages[0]?.names || []);
        }
    }, [usages]);


    const renderExpandAll = () => {
          const countShow = metaData.length;
          const titleText = `${usageType !== "UsageToProduct" ? "Contributors:" : "Titles:"}`;
          if (countShow === 0) {
            return null;
          }
        return (
            <div onClick={() => toggleExtendedMetaData()}>
            {metaData.length > 0 && <div className='arrowIconExpandDiv flexRow cursorPointer'>
                <div className={isExtendedMetaDataOpen ? 'arrowIconExpandAllExpanded paddingRightLarge' : 'arrowIconExpandAll paddingRightLarge'} >
                    <i className={isExtendedMetaDataOpen ? "icon ms-Icon ms-Icon--DoubleChevronUp" : "icon ms-Icon ms-Icon--DoubleChevronDown" } aria-hidden="true" id="expandResultsButton"  title={"Extended Metadata"}></i>
                </div>
                {isExtendedMetaDataOpen ? <div className='arrowIconExpandText'><strong>{"Extended Metadata"}</strong> </div> : <div className='arrowIconExpandText'> <strong>{"Extended Metadata"}</strong></div>}
            </div>}
            <div className={`backgroundLightGray marginVerticalSmall  ${isExtendedMetaDataOpen && "boarderVertical paddingVerticalSmall"}`}>
                    <>
      {isExtendedMetaDataOpen &&  (
        <div className="paddingRightSmall paddingLeftLarge paddingBottomSmall">
          <strong>{titleText} {countShow}</strong>
        </div>
      )}
      </>
            {isExtendedMetaDataOpen && metaData.length > 0 ? <>{renderFourRowsMetaData(metaData)}</> : null}
            </div>
            </div>
        );
    }

const renderFourRowsMetaData = (contributorsOrNames) => {
  const contributorTypeOrder = contributorTypes || ["SA", "AR", "CA", "C", "A", "E", "SE"];
  const nameTypeOrder = nameTypes || ["OT", "SE", "AT", "EP"]; 
  const TYPE_ORDER = isUsageToProduct ? nameTypeOrder : contributorTypeOrder;

  const sortByType = (items = []) => {
    return [...items].sort((a, b) => {
      const aIndex = a.type ? TYPE_ORDER.indexOf(a.type) : -1;
      const bIndex = b.type ? TYPE_ORDER.indexOf(b.type) : -1;
      const aRank = aIndex === -1 ? TYPE_ORDER.length : aIndex;
      const bRank = bIndex === -1 ? TYPE_ORDER.length : bIndex;
      return aRank - bRank;
    });
  };

  const sortedItems = sortByType(contributorsOrNames);

  const itemsPerRow = sortedItems?.length && sortedItems.length <= 50 ? 10 : Math.ceil(sortedItems.length / 5);
  const maxRows = 5;

  const paddedItems = [...sortedItems];
    while (paddedItems.length < maxRows * itemsPerRow) {
    paddedItems.push({}); 
    }

    const rows = Array.from(
    { length: maxRows },
    (_, i) => paddedItems.slice(i * itemsPerRow, (i + 1) * itemsPerRow)
    );

    
  return (
    <div className="flexRow">
      {rows.map((row, rowIdx) => (
        <div key={rowIdx} style={{ flex: 1, padding: 8 }}>
          {row.map((metaData, idx) => {
            return metaData.name || metaData.title ? <div
                className="flexRow marginVerticalVerySmall "
                key={`${metaData.ipiNumber ?? rowIdx}-${idx}`}
            >
              <div style={{ fontWeight: "bold"}} className="paddingRightSmall">
                {metaData.type ? `${metaData.type}:` : ""}
              </div>
              <div
                    className="overflowEllipsis"
                    style={{ flex: 1, minWidth: 0, maxWidth: '300px' }}
                    title={metaData.name} 
              >
                {metaData.name}{metaData.title}
              </div>
            </div> : <></>})}
        </div>
      ))}
    </div>
  );
};

    return ( <>
    {renderExpandAll()}
    </>   )
}

export default UsageMetaDataView